import Newsletter from './Newsletter.vue'
import Contact from './Contact.vue'

export default {
  Newsletter,
  Contact
}
